/**
 * Generate a unique idempotency key for a write request.
 *
 * Prefers the native `crypto.randomUUID`; falls back to a timestamp + random suffix on
 * environments where it is unavailable. The key lets the backend deduplicate a command that is
 * accidentally submitted twice (double click, retry) so the same physical action never repeats.
 *
 * @returns A unique string safe to use as an idempotency key.
 */
export const generateIdempotencyKey = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
};

export default generateIdempotencyKey;
